import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class NewsletterService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetAllItems(query: string, paging?: string) {
        return this.baseApiFactory.getData<any[]>(`/api/Newsletter?${query}&${paging}`);
    }

    public DeleteNewsletter(id: number) {
        return this.baseApiFactory.delete(`/api/Newsletter/${id}`);
    }

    public Update(value: any) {
        return this.baseApiFactory.put('/api/Newsletter', value);
    }
}

lazyRegister.service('NewsletterService', NewsletterService);
